import React from 'react';
import {flowRight as compose} from 'lodash';
import {withTranslation} from 'react-i18next';
import Metadata from '../../../common/components/Metadata';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import Screen from '../../../common/components/layout/Screen';
import PropTypes from 'prop-types';
import {Span} from '../../../common/components/StyledComp';
import {faChartLine} from '@fortawesome/free-solid-svg-icons/faChartLine';
import ChartDashboardAdmin from './ChartDashboardAdmin';
import {Col, Row} from 'reactstrap';
import NumberDashboard from './NumberDashboard';
import styled from 'styled-components';
import {COLORS} from '../../../common/constants';
import {Container} from 'react-bootstrap';
import {Query} from 'react-apollo';
import {PulseLoader} from 'react-spinners';
import gql from 'graphql-tag';

const DashboardContainer = styled(Container)`
  &&&{
    max-width: 95%;
    margin-top: 5px;
    margin-bottom: 33px;
  }
`;

const GRAPHQL_QUERY_ADMIN_METRICS = gql`
  query adminMetrics{
    metrics {
      id
      totalReceipts
      adminUsers {
        id
        totalActiveUsers
        totalActiveMerchants
      }
    }
  }
`;

const DashboardAdmin = ({t}) => {

  return (
    <Screen
      header={<Metadata meta={t('meta')} title={t('title')}/>}
      leftTitle={
        <>
          <FontAwesomeIcon icon={faChartLine} color={'rgb(201,0,95)'}/>
          <Span className="route-name">{t('dashboard')}</Span>
        </>
      }>
      <DashboardContainer>
        <Query query={GRAPHQL_QUERY_ADMIN_METRICS}>
          {({data, loading}) => {
            if (loading) {
              return <PulseLoader />;
            } else if (data && data.metrics) {
              const {totalReceipts, adminUsers} = data.metrics;
              const {totalActiveUsers, totalActiveMerchants} = adminUsers;
              return (
                <Row>
                  <Col xs={4}>
                    <NumberDashboard
                      data={{title: 'activeUsers', value: totalActiveUsers}}
                      backgroundColor={'#20a8d8'}
                      color={COLORS.WHITE}
                    />
                  </Col>
                  <Col xs={4}>
                    <NumberDashboard
                      data={{title: 'activeMerchants', value: totalActiveMerchants}}
                      backgroundColor={'#63c2de'}
                      color={COLORS.WHITE}
                    />
                  </Col>
                  <Col xs={4}>
                    <NumberDashboard
                      data={{title: 'tickets', value: totalReceipts}}
                      backgroundColor={'#f86c6b'}
                      color={COLORS.WHITE}
                    />
                  </Col>
                </Row>
              );
            }
            return null;
          }}
        </Query>
        <Row>
          <Col xs={12} className='chartContainerCol'>
            <ChartDashboardAdmin />
          </Col>
        </Row>
      </DashboardContainer>
    </Screen>
  );
};


DashboardAdmin.propTypes = {
  t: PropTypes.func.isRequired,
};

export default compose(
  withTranslation('dashboard'),
)(DashboardAdmin);
